/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { pontosRoute } from "./pontos/shared/data.service";
import { AuthGuardService } from "../shared/services/auth-guard.service";
import { PontosComponent } from "./pontos/pontos.component";
import { pontosRoutes } from "./pontos/pontos-routing.module";
import { deslocamentosRoute } from "./deslocamentos/shared/data.service";
import { DeslocamentosComponent } from "./deslocamentos/deslocamentos.component";
import { deslocamentosRoutes, deslocamentosVisitanteRoutes } from "./deslocamentos/deslocamentos-routing.module";
import { ViagemConfiguracaoComponent } from "./configuracao/viagem-configuracao.component";
import { configuracaoRoute } from "../shared/services/data.service";
import { destinosRoute } from "./destinos/shared/data.service";
import { DestinosComponent } from "./destinos/destinos.component";
import { destinosRoutes } from "./destinos/destinos-routing.module";
import { passageirosRoute } from "./passageiros/shared/data.service";
import { PassageirosComponent } from "./passageiros/passageiros.component";
import { passageirosRoutes } from "./passageiros/passageiros-routing.module";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class ViagensRoutingModule {}

export const viagensRoutes: any[] = [
    {
        path: '',
        redirectTo: '/' + pontosRoute,
        pathMatch: 'full'
    },{
        path: configuracaoRoute,
        component: ViagemConfiguracaoComponent,
        canActivate: [AuthGuardService]
    },{
        path: configuracaoRoute + '/' + pontosRoute,
        component: PontosComponent,
        canActivate: [AuthGuardService],
        children: pontosRoutes
    },{
        path: configuracaoRoute + '/' + passageirosRoute,
        component: PassageirosComponent,
        canActivate: [AuthGuardService],
        children: passageirosRoutes
    },{
        path: configuracaoRoute + '/' + destinosRoute,
        component: DestinosComponent,
        canActivate: [AuthGuardService],
        children: destinosRoutes
    },{
        path: deslocamentosRoute,
        component: DeslocamentosComponent,
        canActivate: [AuthGuardService],
        children: deslocamentosRoutes
    }
];

export const viagensVisitantesRoutes: any[] = [
    {
        path: deslocamentosRoute,
        component: DeslocamentosComponent,
        canActivate: [AuthGuardService],
        children: deslocamentosVisitanteRoutes
    }
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/viagens-routing.module.ts
 **/